import type {ReactNode} from "react";
import {DrawerBody, DrawerTitle} from "../../../../components/ui/drawer";
import {InnerDrawerProps, withDrawer} from "../../../../state/withDrawer";
import {DrawerPageHeader} from "../ProcessesDemo/components/DrawerPageHeader";
import T from "platformed-components/i18n/T";

/**
 * Generic activity-drawer chrome: the standard "Activity" drawer header and
 * body. The activity feed itself is supplied as `children`, because the way an
 * entity's activity is fetched and rolled up is entity-specific (e.g. audit
 * plan pages roll up their descendant subtree, whereas a flat entity shows a
 * single stream). Both drivers render over the shared `components/ActivityStream`
 * primitives; only this chrome is shared.
 */
export const ActivityDrawer = withDrawer(
  ({children}: InnerDrawerProps & {children: ReactNode}) => (
    <>
      <DrawerPageHeader
        title={
          <DrawerTitle>
            <T keyName="c.Activity" />
          </DrawerTitle>
        }
      />
      <DrawerBody px={6} py={5}>
        {children}
      </DrawerBody>
    </>
  ),
  {placement: "end", size: "lg"},
);
